import type { Area } from '@common/types/Area'
import { useMemo } from 'react'

export function useLinesThroughAreas(areas: Area[]): string[] {
	return useMemo(
		() => [
			...new Set(
				[...areas].flatMap(object => {
					return object.lines
				}),
			),
		],
		[areas],
	)
}
